export default function (word) {
  let cleanName = word;
  [ ['Ä', 'Ae'], ['Ö', 'Oe'], ['Ü', 'Ue'],
    ['ä', 'ae'], ['ö', 'oe'], ['ü', 'ue'],
    ['ß', 'ss'] ].forEach(char => {
    cleanName = cleanName.replaceAll(char[0], char[1]);
  });
  return cleanName;
}

